import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IndexedDbService {

  private dbPromise: Promise<IDBDatabase>;

  constructor() {
    this.requestPersistentStorage();  // Request persistent storage
    this.dbPromise = new Promise((resolve, reject) => {
      const request = indexedDB.open('LoggingDB', 1);

      request.onupgradeneeded = event => {
        const db = (event.target as IDBOpenDBRequest).result;
        db.createObjectStore('preferences', { keyPath: 'id' });
      };

      request.onsuccess = event => {
        resolve((event.target as IDBOpenDBRequest).result);
      };

      request.onerror = event => {
        reject((event.target as IDBOpenDBRequest).error);
      };
    });
  }

   // Method to request persistent storage
   private requestPersistentStorage(): void {
    const nativeLog = (window as any).__originalConsoleLog ?? console.log.bind(console);
    if (navigator.storage && navigator.storage.persist) {
      navigator.storage.persist().then(granted => {
        if (granted) {
          nativeLog("Persistent storage has been granted.");
        } else {
          nativeLog("Persistent storage was not granted.");
        }
      }).catch(error => {
        nativeLog("Error requesting persistent storage", error);
      });
    } else {
      nativeLog("Persistent storage API is not supported in this browser.");
    }
  }

  async get(key: string): Promise<any> {
    const db = await this.dbPromise;
    return new Promise((resolve, reject) => {
      const transaction = db.transaction('preferences', 'readonly');
      const store = transaction.objectStore('preferences');
      const request = store.get(key);

      request.onsuccess = () => {
        resolve(request.result?.value);
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  }

  async set(key: string, val: any): Promise<void> {
    const db = await this.dbPromise;
    return new Promise((resolve, reject) => {
      const transaction = db.transaction('preferences', 'readwrite');
      const store = transaction.objectStore('preferences');
      const request = store.put({ id: key, value: val });

      request.onsuccess = () => {
        resolve();
      };

      request.onerror = () => {
        reject(request.error);
      };
    });
  }
}
